import { Input, TimePicker } from 'antd';
import breakpoints from 'constants/breakpoints';
import useWindowSize from 'hooks/useWindowSize';
import moment from 'moment';
import React, { ChangeEvent, useMemo } from 'react';
import styled from 'styled-components';
import { hasTouchScreenCheck } from 'utils';

import { ICommonInputProps } from './types';

const InputStyled = styled(Input)`
  width: 100%;
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    outline: none;
  }
`;

const TimePickerInput: React.FC<ICommonInputProps> = ({
  name,
  inputClassName,
  onChange,
  defaultValue,
  value,
  onBlur,
}) => {
  const windowSize = useWindowSize();
  const isMobile = useMemo(() => {
    let isMobileCheck = hasTouchScreenCheck();
    if (isMobileCheck) {
      if (windowSize.width < parseFloat(breakpoints.md)) {
        isMobileCheck = true;
      } else isMobileCheck = false;
    }
    return isMobileCheck;
  }, [windowSize]);

  const handleChange = (_: any, dateString: string) => {
    onChange?.(dateString);
    // field.onChange(e);
  };

  const handleChangeMobileVer = (event: ChangeEvent<HTMLInputElement>) => {
    const timeString = event.target.value;
    onChange?.(timeString);
  };

  // useEffect(() => {
  //   if (defaultValue && onChange) onChange(defaultValue);
  // }, []);
  const format = 'HH:mm';

  return (
    <>
      {isMobile ? (
        <InputStyled
          type='time'
          name={name}
          value={value}
          className={`time-picker-input ${inputClassName}`}
          // format={format}
          onChange={handleChangeMobileVer}
          onBlur={onBlur}
        />
      ) : (
        <TimePicker
          style={{ width: '100%' }}
          name={name}
          defaultValue={defaultValue ? moment(defaultValue, format) : undefined}
          value={value ? moment(value, format) : undefined}
          className={`time-picker-input ${inputClassName}`}
          format={format}
          onChange={handleChange}
          popupClassName='antd-time-picker-specific'
          onBlur={onBlur}
        />
      )}
    </>
  );
};

export default React.memo(TimePickerInput);
